import { render } from "./DynvibeDynamic.vue?vue&type=template&id=5900a6ae&scoped=true"
import script from "./DynvibeDynamic.vue?vue&type=script&lang=js"
export * from "./DynvibeDynamic.vue?vue&type=script&lang=js"

import "./DynvibeDynamic.vue?vue&type=style&index=0&id=5900a6ae&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5900a6ae"]])

export default __exports__